import React, {Component} from "react";
import {connect} from "react-redux";
import {Popover} from "antd";
import {fetchApplications, loadApplication, changeApplication} from "appRedux/actions/Application";

class AppsNavigation extends Component {
  constructor() {
    super();
    this.state = {
      currentApplication: JSON.parse(localStorage.getItem('bms-current-application')) || false
    }

    this.changeCurrentApplication.bind(this);
  }

  componentDidMount() {
    console.log('this.props.applications.length', this.props.applications.length);
    console.log('this.props.selectedApplication', this.props.selectedApplication);
    if (this.props.applications.length > 0) {
      if (!this.props.selectedApplication) {
        this.props.changeApplication(this.props.applications[0]);
        this.setState({
          currentApplication: this.props.applications[0]
        });
        localStorage.setItem('bms-current-application', JSON.stringify(this.props.applications[0]));
      }
    }

    this.props.loadApplication(JSON.parse(localStorage.getItem('bms-current-application')) || false);
  }

  componentWillReceiveProps(newProps) {
    console.log('newProps', newProps);
    if (newProps.applications && newProps.applications.length > 0) {
      if (!this.state.currentApplication) {
        // this.setState({
        //   currentApplication: newProps.applications[0]
        // });
        //
        // localStorage.setItem('bms-current-application', JSON.stringify(newProps.applications[0])) ;
        this.props.changeApplication(newProps.applications[0]);
      }
    }

    if ((newProps.selectedApplication &&
      (newProps.selectedApplication.applicationId != this.state.currentApplication.applicationId
      || newProps.selectedApplication.name != this.state.currentApplication.name
    || newProps.selectedApplication.remark != this.state.currentApplication.remark)
    || !this.state.currentApplication) ||
      (this.state.currentApplication && !newProps.selectedApplication)) {
        this.setState({
          currentApplication: newProps.selectedApplication
        });
      }
  }

  changeCurrentApplication(application) {
    this.setState({
      currentApplication: application
    });

    localStorage.setItem('bms-current-application', JSON.stringify(application));
    window.location.reload();
  }

  render() {
    const {applications} = this.props;
    const appMenuOptions = (
      <ul className="gx-user-popover">
      {
        applications ? applications.map((a) => (
          <li onClick={(e) => this.changeCurrentApplication(a)} key={a.applicationId}>{a.name}</li>
        )) : ''
      }
      </ul>
    );

    return (

      <div className="gx-flex-row gx-align-items-center gx-ml-2 gx-mb-2 gx-avatar-row">
        <ul className="gx-app-nav">
          <li><i className="icon icon-apps"/></li>
        </ul>
        <Popover className="gx-avatar-name" style={{width: '150px', marginTop: '10px'}} placement="bottomRight" content={appMenuOptions} trigger="click">
          <span style={{marginLeft: '28px'}}>
            {this.state.currentApplication ? this.state.currentApplication.name : 'No Application'}
          </span>
          <span style={{position: 'absolute', right: '18px'}}><i className="icon icon-chevron-down gx-fs-xxs gx-ml-2"/></span>
        </Popover>
      </div>

    )

  }
}

const mapStateToProps = ({application}) => {
  const {applications, selectedApplication} = application;
  return {applications, selectedApplication};
};

export default connect(mapStateToProps, {
  fetchApplications,
  loadApplication,
  changeApplication
})(AppsNavigation);
